module.exports = __webpack_public_path__ + "static/media/confirm-rego.cc349f95.png";